import { render, staticRenderFns } from "./ChatDialogs.vue?vue&type=template&id=52f2f484&"
import script from "./ChatDialogs.vue?vue&type=script&lang=js&"
export * from "./ChatDialogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports